import { t } from '$lib/i18n';
import type { ValidationI18n } from '$lib/components/form';
import { createValidationI18n } from '$lib/components/form';
import { formatWithoutExponent } from '@adminsoft/ui/utils/number-format';

export function getAppValidationI18n(): ValidationI18n {
	return createValidationI18n({
		required: t('required'),
		minLength: (min) => t('minLength', { minLength: String(min) }),
		maxLength: (max) => t('maxLength', { maxLength: String(max) }),
		numericMin: (min) => t('valueMustBeGreaterOrEqualThan', { minValue: formatWithoutExponent(min) }),
		numericMax: (max) => t('valueMustBeSmallerOrEqualThan', { maxValue: formatWithoutExponent(max) }),
		numericExclusiveMin: (min) => t('valueMustBeGreaterThan', { minValue: formatWithoutExponent(min) }),
		numericExclusiveMax: (max) => t('valueMustBeSmallerThan', { maxValue: formatWithoutExponent(max) }),
		mustSelectAtLeastOne: t('mustSelectAtLeastOne'),
		invalidFormat: t('invalidFormat'),
		notTrimmed: t('notTrimmed'),
		dateMustBeAfter: (date) => t('dateMustBeAfter', { date }),
		dateMustBeBefore: (date) => t('dateMustBeBefore', { date })
	});
}
